import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ResponsiveContext } from '../contexts/ResponsiveContext';
import Mastercard from '../assets/img/mastercard.webp';
import Visa from '../assets/img/visa.webp';

const Footer = () => {
  const { is450, is775 } = useContext(ResponsiveContext);

  return (
    <div className='footer '>
      <div
        className={`container d-flex ${
          is775 ? 'flex-row' : 'flex-column'
        } justify-content-between align-items-center p-3`}
      >
        <div>
          <Link className=' my-2' to='/shipping-policy'>
            <i>
              <b>Política de Envío</b>
            </i>
          </Link>
        </div>
        <div
          className='justify-content-center d-flex'
          style={{ marginTop: is775 ? '' : '30px' }}
        >
          <div className={`card-name ${is450 ? 'mx-5' : 'mx-4'} `}>
            <img alt='mastercard' src={Mastercard} style={{ width: '70px' }} loading="lazy"/>
          </div>
          <div className={`card-name ${is450 ? 'mx-5' : 'mx-4'} `}>
            <img alt='visa' src={Visa} style={{ width: '70px' }} loading="lazy"/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
